import { useAppContext } from '../useAppContext';
import { sendBQ, mapWidgetType, WIDGET_TYPE } from '../../../../lib/bq';
import { isBuilder } from '../../utils/helpers';
import { MODE, VERSION } from '../../../../constants';

interface BqEventProps {
    type: string;
    affiliateId: string;
    afp1: string;
    widgetType: MODE;
    version: VERSION;
    gigId?: number;
}

interface BqEvent {
    type: string;
    group: string;
    affiliation: {
        id: string;
    };
    gig?: {
        id: number;
    };
    page: {
        referrer: {
            source: string;
        };
        element: {
            metadata: {
                widget_type: WIDGET_TYPE;
            };
            version: VERSION;
        };
    };
}

export const bqEvent = (props: BqEventProps): BqEvent => {
    const { type, affiliateId, afp1, widgetType, version, gigId } = props;

    const event: BqEvent = {
        type,
        group: 'nga',
        affiliation: {
            id: affiliateId,
        },
        page: {
            referrer: {
                source: afp1,
            },
            element: {
                metadata: {
                    widget_type: mapWidgetType(widgetType),
                },
                version,
            },
        },
    };

    if (gigId) {
        event.gig = {
            id: gigId,
        };
    }

    return event;
};

interface SendBqEventProps {
    type: string;
    affiliateId: string;
    afp1: string;
    widgetType: MODE;
    gigId?: number;
}

export const useBQ = () => {
    const { version } = useAppContext();

    const sendBQEvent = (props: SendBqEventProps) => {
        if (isBuilder) {
            return;
        }

        const { type, affiliateId, afp1, widgetType, gigId } = props;

        const event = bqEvent({
            type,
            affiliateId,
            afp1,
            widgetType,
            version,
            gigId,
        });

        sendBQ(event);
    };

    return {
        sendBQEvent,
    };
};
